










































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Validator } from 'vee-validate';
import { Base } from './base';
import { accountReceivableService } from '@/shared';

@Component({
    components: {
        Grid: () => import('./app.grid.vue'),
    },
    props: ['dialog', 'recordKey', 'isEnablePublicNote', 'guid'],

})

export default class NoteComponent extends Base {
    public isEnablePublicNote: boolean;
    public isPublic: boolean =false;
    public docDescription: string = "";
    public isChargeCustomerScreen: boolean = false;
    public docNumber: any[] = [];
    public selectedDocNumber: string = "";
    public accountLoading: boolean = false;

    get trigger(): boolean {
        return this.$props.dialog;
    }
    set trigger(val) {
        this.$emit('closedialog', val);
    }
    public $validator: Validator;
    public loading: boolean = false;
    public pagination = new PaginationModel('createdAt', true, 5);
    public dialog: boolean;
    public recordKey: string;
    public guid: string;
    public noteText: string = '';
    public storeId: number = 0;
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public headers: VHeaders[] = [
        {
            text: this.$parent.$t('noteComponent.headers.note') as string,
            align: 'left',
            sortable: true,
            value: 'noteText',
        },
        {
            text: "Document Number",
            align: 'left',
            sortable: true,
            value: 'docNumber',
            fieldType: 'template',
            template: (item) => {
                if (item.docNumber && item.docNumber != "")
                    return `<span>${item.docNumber}</span>`;
                else
                    return `<span> N/A </span>`;
            }
        },
        {
            text: "Document Description",
            align: 'left',
            sortable: true,
            value: 'docDescription',
            fieldType: 'template',
            template: (item) => {
                if (item.docDescription && item.docDescription != "")
                    return `<span>${item.docDescription}</span>`;
                else
                    return `<span> N/A </span>`;
            }
        },
        {
            text: 'Public',
            align: 'left',
            value: 'isPublic',
            sortable: false,
            fieldType: 'switch',
            title: 'Receive Email',
            onChange: (item: any): void => {
                this.updateNote(item);
            }
        },
        {
            text: this.$parent.$t('noteComponent.headers.addedAt') as string,
            value: 'createdAt',
            align: 'left',
            fieldType: 'date',
        },
        {
            text: this.$parent.$t('noteComponent.headers.addedBy') as string,
            value: 'createdByEmail',
            align: 'left',
        },
        {
            align: 'center',
            isNotDataProp: true,
            text: 'Action',
            sortable: false,
        }
    ];
    public items: any = [];
    public requestProgress: boolean = false;

    public mounted() {
        this.isChargeCustomerScreen = this.$route.name.includes("app.customercharges") ? true : false;

        if (this.isChargeCustomerScreen) {
            this.$watch('guid', (newVal, oldVal) => {
                this.getChargeCustomerAccountNumber(newVal);
            });
        }

        this.$watch('recordKey', (newVal, oldVal) => {
            this.getNotes(newVal);
        });
    }
    public async getNotes(recordKey): Promise<void> {
        try {
            this.loading = true;
            const response = await accountReceivableService.getNoteAsync(recordKey);
            this.items = [];
            this.items = response.results;
            if (this.items) {
                this.pagination.totalItems = response.results.length || 0;
            }
        } finally {
            this.loading = false;
        }
    }

    // public async changeAccountNumber(): Promise<void> {
    //     this.selectedDocNumber = '';
    // }

    public async saveNote(): Promise<void> {
        if (this.validateForm()) {
            if (this.isEnablePublicNote == false) {
                this.docDescription = '';
                this.selectedDocNumber = '';
            } else  {
                this.noteText = '';
            }

            if (!this.noteText && !this.docDescription) {
                return;
            }

            try {
                await accountReceivableService.addNoteAsync(this.recordKey, this.noteText, this.isEnablePublicNote,
                    this.selectedDocNumber, this.docDescription, this.isPublic);
                this.noteText = '';
                this.docDescription = '';
                this.selectedDocNumber = '';
                this.getNotes(this.recordKey);
                this.showAlert(true, this.$parent.$t('noteComponent.noteAddedSuccessfully'));
                this.$validator.reset();
            } finally {
                this.requestProgress = false;
            }
        }
    }

    public async updateNote(item): Promise<void> {
        try {
            // item.isPublic = !item.isPublic;
            await accountReceivableService.updateNoteAsync(this.recordKey, item, item.isPublic);
            this.getNotes(this.recordKey);
        } catch (e) {
        }
    }

    public async deleteNote(item): Promise<void> {
        try {
            await accountReceivableService.deleteNoteAsync(this.recordKey, item);
            this.showAlert(true, 'Note Deleted Successfully');
            this.getNotes(this.recordKey);
        } catch (e) {
        }
    }

    public async getChargeCustomerAccountNumber(guid) {
        try {
            this.accountLoading = true;
            var response = await accountReceivableService.getChargeCustomerAccountNumbers(guid);
            this.docNumber = response.documentNumber;
        } finally {
            this.accountLoading = false;
        }
    }

    public closeDialog() {
        this.trigger = false;
        this.$validator.reset();
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
    }

    public actions = [
        {
            type: 'button',
            icon: 'fas fa-trash-alt',
            title: 'Delete',
            color: 'error',
            action: (model: any) => {
                this.deleteNote(model);
            },
        },
    ];
}
